import {createContext} from 'react';

const proyectoContext = createContext();

export default proyectoContext;